module.exports = __webpack_public_path__ + "img/link-bmou.53f28af2.png";